<template>
  <v-container class="fill-height pb-0" >
    <v-card class="e-cardLeccion-intro e-elevation--4 e-border--radius fill-height">
      <v-card-text class="e-cardLeccion-intro-title py-2 justify-start d-flex-column">
        <p class="e-description-small mb-0 text-xs-left ">{{ tema }}</p>
        <p class="e-description-big mb-0 text-xs-left">{{ subtema }}</p>
      </v-card-text>
      <v-card-text class="e-cardLeccion-intro-text px-4 align-start d-flex justify-end">
        <v-layout style="width: 100%" row wrap>
          <v-flex xs4 class="e-description-middle text-xs-center align-center justify-center" style="display: flex; border-right: 1px solid #f7f9fc">듣다</v-flex>
          <v-flex xs8 class="e-description-middle text-xs-center">
            <p class="mb-0"><span class="primary--text">듣</span>+ ~은 다음에</p>
            <div class="primary--text py-1"><v-icon class="primary--text">arrow_downward</v-icon></div>
            <p><span class="primary--text">듣</span>+ ~은 다음에</p>
          </v-flex>
          <v-flex xs12>
            <v-btn block class="elevation-0 e-description-middle primary-light" round>들<span style="color: #8B90A0">은 다음에</span></v-btn>
          </v-flex>
          <v-flex xs12 py-3>
            <hr style="border: none; height: 1px; background: #f7f9fc ">
          </v-flex>
          <v-flex xs4 class="e-description-middle text-xs-center align-center justify-center" style="display: flex; border-right: 1px solid #f7f9fc">듣다</v-flex>
          <v-flex xs8 class="e-description-middle text-xs-center">
            <p class="mb-0"><span class="primary--text">듣</span>+ ~은 다음에</p>
            <div class="primary--text py-1"><v-icon class="primary--text">arrow_downward</v-icon></div>
            <p><span class="primary--text">듣</span>+ ~은 다음에</p>
          </v-flex>
          <v-flex xs12>
            <v-btn block class="elevation-0 e-description-middle primary-light" round>들<span style="color: #8B90A0">은 다음에</span></v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'LeccionIntro',
  props: {
    tema: {
      type: String,
      default: 'Irregular'
    },
    subtema: {
      type: String,
      default: '‘ㄷ’'
    }
  }
}
</script>
